<template>
  <fieldset
    ref="root"
    :class="{
      'slo-radio-images': true,
      'focus-within': fieldState.focusWithin,
    }"
    v-bind="$attrs"
    @input.stop="handleInput($event)"
  >
    <ul>
      <li v-if="fallback" class="image-wrapper">
        <label :class="!value ? 'checked' : ''">
          <input
            type="radio"
            :value="undefined"
            :name="name"
            :checked="!value"
            @focus.stop="handleInput($event)"
          />
          <img :src="fallback" width="185" height="185" />
        </label>
      </li>
      <li v-for="image of images" :key="image.id" class="image-wrapper">
        <label :class="image.value === value ? 'checked' : ''">
          <input
            type="radio"
            :value="image.value"
            :checked="image.value === value"
            :name="name"
            @focus.stop="handleInput($event)"
          />
          <img :src="image.src" :alt="image.alt" width="185" height="185" />
        </label>
      </li>
    </ul>
  </fieldset>
</template>

<script>
import {isArray} from '../../js/main/utils';

export default {
  name: 'SloRadioImages',
  inject: {
    fieldState: {name: 'fieldState', default: {}}
  },
  props: {
    fallback: {type: String},
    images: {
      validator: function(value) {
        return isArray(value) && value.every(item => item.value && item.src);
      }
    },
    value: {type: String},
    name: {type: String}
  },
  methods: {
    handleInput($event) {
      this.$emit('input', $event.target.value);
    }
  }
};
</script>

<style scoped lang="scss">
@import '../../scss/system';

.slo-radio-images {
  ul {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    padding: 0;
    max-width: 100%;
    margin: -8px;

    > li {
      list-style: none;
      margin: 8px;
    }
  }

  label {
    position: relative;
    width: 100%;
    margin: 0;
    cursor: pointer;

    &:before {
      content: '';
      display: block;
      width: 100%;
      padding-top: 100%;
    }

    img {
      object-fit: cover;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }

    &.checked:after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-color: transparent;
      border: 4px solid #006bb6;
    }
  }

  input[type='radio'] {
    opacity: 0;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    pointer-events: none;
  }

  .slo-radio-images--ring,
  img {
    pointer-events: none;
  }
}

.slo-radio-images--ring {
  position: absolute;
  top: -2px;
  left: -2px;
  width: 84px;
  height: 84px;
  border: 4px solid $color-blue-400;
  border-radius: 2px;
  transition: transform 200ms ease-out;

  margin: 0 !important;
  z-index: 1;
}

.image-wrapper {
  width: calc(50% - 16px);

  @include screen(sm) {
    width: calc(25% - 16px);
  }
}
</style>
